<template>
  <b-container class="automation">
    <b-row>
      <b-col md="12">
        <h2 class="dashboard__title">
          Automation
          <span class="general-buttons">
            <router-link
              :to="{ name: 'AutomationSettings' }"
              class="btn btn-main btn-round"
              tag="span">
              <icon name="cog"/> Settings
            </router-link>
          </span>
        </h2>
      </b-col>
      <b-col md="12">
        <div>
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <router-link
                :to="{name: 'AutomatedResponses'}"
                active-class="active"
                class="nav-link">Automated Responses</router-link>
            </li>
          </ul>
        </div>
        <div class="my-5">
          <router-view/>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import '@/assets/css/modules/_automation.scss';

export default {
  name: 'Automation',
};
</script>
